<div [ngClass]="{ dark: this.themeService.isDark }">
  <!-- Toast global para toda la aplicacion -->
  <p-toast position="bottom-right" key="br" [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}"></p-toast>
  <!-- Muestra el modal de la notificacion de las transacciones -->
  <app-modal-detalles-transaccion #modalDetallesTransaccion></app-modal-detalles-transaccion>
  <!--  -->
  @if(loading){
    <app-loading></app-loading>
  } @else {
    <app-pop-up></app-pop-up> 
  }
  <app-tour></app-tour>
  <app-session-modal
    *ngIf="showModal"
    [countdown]="countdown"
    [visible]="showModal"
    (stayActive)="onStayActive()"
    (click)="$event.stopPropagation()"
  ></app-session-modal>
  <!-- Rutas de toda la aplicacion -->
  <router-outlet></router-outlet>
  <!-- <app-responsive-helper></app-responsive-helper> -->
</div>
